module.exports = __webpack_public_path__ + "img/25.99f9f59c.png";